<!--GeneratorFlag:[NoChange]-->
<template>
	<kaveh-content :loading="loading" width="800px">
		<kaveh-list v-if="temp" :entity="entity" :data="temp" />
	</kaveh-content>
</template>
<script>
	import { PersonNationality } from '@/modules/hub/data/person-nationality/detail'
	import { PersonNationalityService } from '@/modules/hub/services'
	export default {
		data()
		{
			return {
				temp: null,
				loading: true
			}
		},
		computed:
		{
			entity()
			{
				return PersonNationality
			},

			service()
			{
				return new PersonNationalityService()
			},
		},
		async beforeMount()
		{
			await this.init()
		},
		methods:
		{
			async init()
			{
				this.temp = await this.getDataFromService();
				if (this.temp == undefined)
				{
					this.$router.go(-1)
				}
			},

			async getDataFromService()
			{
				var result;
				const temp = await this.getDataFromTemp();

				if (temp)
				{
					try
					{
						this.loading = true;
						const payload = {
							'personNationalityId': temp['personNationalityId']
						};
						const res = await this.service.detail(payload)
						result = res.data

					} catch (e) { console.log(e) }
				}

				this.loading = false;
				return result;
			},

			async getDataFromTemp()
			{
				const store = this.$store;
				const router = this.$route;
				const temp = await store.dispatch('temp/findByQuery', router.query);

				return temp ? temp.value : undefined;
			}
		}
	}
</script>